
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";
import {
  CLEAR_MANPOWER_ATTENDANCE_REPORT_DATA,
  CREATE_ATTENDANCE_SUCCESS,
  FETCH_ATTENDANCE_SUCCESS, FETCH_MANPOWER_ATTENDANCE_REPORT_DATA_SUCCESS,
  GET_ATTENDANCE_SUCCESS,
  SAVE_ATTENDANCE_QUERY
} from "../../constants/ActionTypes";
import axios from 'util/Api'
import {
  fetchError,
  fetchStart,
  fetchSuccess,
} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";
import moment from "moment";

export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_ATTENDANCE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ATTENDANCE_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    // type: CREATE_ATTENDANCE_SUCCESS,
    type: FETCH_ATTENDANCE_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_ATTENDANCE_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {
    // console.log('getting....')
    dispatch(fetchStart());
    try {
      const {manpowerAttendance} = store.getState();
      const {query} = manpowerAttendance;
      const response = await axios.get(`/manpower-attendance?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const {manpowerAttendance} = store.getState();
      const {query} = manpowerAttendance;
      const response = await axios.get(`/manpower-attendance/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/manpower-attendance`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};


export const fetchResource = (manpower) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/manpower-attendance/${moment().format('YYYY-MM-DD')}`);
      // console.log(response)
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchReportDataSuccess = ({data}) => {
  return {
    type: FETCH_MANPOWER_ATTENDANCE_REPORT_DATA_SUCCESS,
    data
  };
};

export const clearReportData = () => {
  return {
    type: CLEAR_MANPOWER_ATTENDANCE_REPORT_DATA
  };
};

export const getReport = payload => {
  return async dispatch => {
    dispatch(fetchStart);

    try {
      const response = await axios.post(
        `/manpower-attendance/report/`,
        payload
      );
      dispatch(fetchSuccess());
      dispatch(fetchReportDataSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};
